/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAiUsageBilling extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAiUsageBilling");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAiUsageBilling.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAiUsageBilling>): BackgroundJobPayloadForAiUsageBilling {
        let obj = Object.assign(new BackgroundJobPayloadForAiUsageBilling(), model);
        BackgroundJobPayloadForAiUsageBilling.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAiUsageBilling>): BackgroundJobPayloadForAiUsageBilling {
        if (!model) return null;
        return BackgroundJobPayloadForAiUsageBilling.newInstance(<BackgroundJobPayloadForAiUsageBilling> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAiUsageBilling) {
        if (!obj) return;

        models.BackgroundJobPayloadForAiUsageBilling.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAiUsageBilling): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAiUsageBilling.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.backfill_start_date === "string") {
            this.backfill_start_date = new Date(<string><any>this.backfill_start_date);
        }
        if (typeof this.backfill_end_date === "string") {
            this.backfill_end_date = new Date(<string><any>this.backfill_end_date);
        }
    }

    /**
     * Target AI Service Account
     */
    service_account_id: string;

    /**
     * Provider can extract caller from billing (AWS CUR); selects CUR-native strategy
     */
    support_ai_caller_extract: boolean = false;

    backfill_start_date: Date;

    backfill_end_date: Date;

}
